import { CONFIG } from '@/constants';
import { get } from '@/utils/runtime-config';

const DEFAULT_INDEX = 0;

// Getter dinamico per LIST
const getList = () => {
  try {
    const chains = get('chainSelector.chains', []);
    return chains;
  } catch (error) {
    console.error('Failed to load chain selector configuration:', error);
    return [];
  }
};

const getDefaultIndex = () => {
  try {
    return get('chainSelector.defaultIndex', DEFAULT_INDEX);
  } catch (error) {
    return DEFAULT_INDEX;
  }
};

const INFO = (chainId) => {
  if (!chainId) {
    throw new Error('chainId is required for Keplr configuration');
  }

  const list = getList();
  const currentLcd = get('chain.lcd', '');
  const index = list.findIndex((item) => item.lcd === currentLcd);

  if (index < 0) {
    return null;
  }

  return Object.freeze({
    rpc: list[index].rpc,
    rest: list[index].lcd,
    chainId: chainId,
    chainName: list[index].chainName,
    stakeCurrency: {
      coinDenom: CONFIG.TOKEN_STAKE.SYMBOL,
      coinMinimalDenom: CONFIG.TOKEN_STAKE.DENOM,
      coinDecimals: CONFIG.TOKEN_STAKE.EXPONENT,
    },
    bip44: {
      coinType: CONFIG.COIN_TYPE,
    },
    bech32Config: {
      bech32PrefixAccAddr: CONFIG.PREFIXES.ACCOUNT.ADDRESS,
      bech32PrefixAccPub: CONFIG.PREFIXES.ACCOUNT.KEY,
      bech32PrefixValAddr: CONFIG.PREFIXES.VALIDATOR.OPERATOR.ADDRESS,
      bech32PrefixValPub: CONFIG.PREFIXES.VALIDATOR.OPERATOR.KEY,
      bech32PrefixConsAddr: CONFIG.PREFIXES.VALIDATOR.CONSENSUS.ADDRESS,
      bech32PrefixConsPub: CONFIG.PREFIXES.VALIDATOR.CONSENSUS.KEY,
    },
    currencies: [
      {
        coinDenom: CONFIG.TOKEN_STAKE.SYMBOL,
        coinMinimalDenom: CONFIG.TOKEN_STAKE.DENOM,
        coinDecimals: CONFIG.TOKEN_STAKE.EXPONENT,
      },
      {
        coinDenom: CONFIG.TOKEN_CREDIT.SYMBOL,
        coinMinimalDenom: CONFIG.TOKEN_CREDIT.DENOM,
        coinDecimals: CONFIG.TOKEN_CREDIT.EXPONENT,
      },
    ],
    feeCurrencies: [
      {
        coinDenom: CONFIG.TOKEN_CREDIT.SYMBOL,
        coinMinimalDenom: CONFIG.TOKEN_CREDIT.DENOM,
        coinDecimals: CONFIG.TOKEN_CREDIT.EXPONENT,
        gasPriceStep: {
          low: CONFIG.GAS_PRICE_STEP.LOW,
          average: CONFIG.GAS_PRICE_STEP.AVERAGE,
          high: CONFIG.GAS_PRICE_STEP.HIGH,
        },
      },
      {
        coinDenom: CONFIG.TOKEN_STAKE.SYMBOL,
        coinMinimalDenom: CONFIG.TOKEN_STAKE.DENOM,
        coinDecimals: CONFIG.TOKEN_STAKE.EXPONENT,
        gasPriceStep: {
          low: CONFIG.GAS_PRICE_STEP.LOW,
          average: CONFIG.GAS_PRICE_STEP.AVERAGE,
          high: CONFIG.GAS_PRICE_STEP.HIGH,
        },
      },
    ],
  });
};

export default Object.freeze({
  get DEFAULT_INDEX() {
    return getDefaultIndex();
  },
  INFO,
  get LIST() {
    return getList();
  },
});
